import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AutomationShowcase from "@/components/automation/AutomationShowcase";
import Services from "@/components/Services";
import About from "@/components/About";
import Leadership from "@/components/Leadership";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Leadership />
        <AutomationShowcase />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};


export default Index;
